const SELECT_SHIPPING_METHOD = "checkout/shipping/SELECT_SHIPPING_METHOD";
const SELECT_STORE = "checkout/shipping/SELECT_STORE";
const SELECT_SERVICE_STORE = "checkout/shipping/SELECT_SERVICE_STORE";
const SELECT_PICKUP_POINT = "checkout/shipping/SELECT_PICKUP_POINT";
const SET_CONSENTS = "checkout/shipping/SET_CONSENTS";
const TOGGLE_CONSENT = "checkout/shipping/TOGGLE_CONSENT";
const TOGGLE_DELIVERY_ADDRESS = "checkout/shipping/TOGGLE_DELIVERY_ADDRESS";
const TOGGLE_IS_COMPANY = "checkout/shipping/TOGGLE_IS_COMPANY";
const TOGGLE_INVOICE = "checkout/shipping/TOGGLE_INVOICE";
const UPDATE_SHIPPING_DETAILS = "checkout/shipping/UPDATE_SHIPPING_DETAILS";
const SAVE_ADDRESS_LOOKUP = "checkout/shipping/SAVE_ADDRESS_LOOKUP";
const PREFILL_SHIPPING_FORMS = "checkout/shipping/PREFILL_SHIPPING_FORMS";
const UPDATE_SHIPPING_FORMS = "checkout/shipping/UPDATE_SHIPPING_FORMS";
const MARK_FIELDS_TOUCHED = "checkout/shipping/MARK_FIELDS_TOUCHED";
const SET_MY_ACCOUNT_VALIDATION = "checkout/shipping/SET_MY_ACCOUNT_VALIDATION";
const RESET_MY_ACCOUNT_VALIDATION = "checkout/shipping/RESET_MY_ACCOUNT_VALIDATION";
const SET_SERVICE_STORE_VALIDATION = "checkout/shipping/SET_SERVICE_STORE_VALIDATION";
const RESET_SERVICE_STORE_VALIDATION = "checkout/shipping/RESET_SERVICE_STORE_VALIDATION";
const RESET_EXPRESS_CHECKOUT = "checkout/shipping/RESET_EXPRESS_CHECKOUT";
const RESET_STORE = "checkout/shipping/RESET_STORE";
const TOGGLE_EXPRESS_CHECKOUT = "checkout/shipping/TOGGLE_EXPRESS_CHECKOUT";
const resetExpressCheckout = () => ({
  type: RESET_EXPRESS_CHECKOUT
});
const selectShippingMethod = (payload) => ({
  type: SELECT_SHIPPING_METHOD,
  payload
});
const resetStore = () => ({
  type: RESET_STORE
});
const selectStore = (payload) => ({
  type: SELECT_STORE,
  payload
});
const selectServiceStore = (payload) => ({
  type: SELECT_SERVICE_STORE,
  payload
});
const selectPickupPoint = (payload) => ({
  type: SELECT_PICKUP_POINT,
  payload
});
const toggleDeliveryAddress = (payload) => ({
  type: TOGGLE_DELIVERY_ADDRESS,
  payload
});
const setConsents = (payload) => ({
  type: SET_CONSENTS,
  payload
});
const toggleConsent = (payload) => ({
  type: TOGGLE_CONSENT,
  payload
});
const toggleIsCompany = (payload) => ({
  type: TOGGLE_IS_COMPANY,
  payload
});
const toggleInvoice = (payload) => ({
  type: TOGGLE_INVOICE,
  payload
});
const toggleExpressCheckout = (payload) => ({
  type: TOGGLE_EXPRESS_CHECKOUT,
  payload
});
const prefillShippingForms = (payload) => {
  return {
    type: PREFILL_SHIPPING_FORMS,
    payload
  };
};
const updateShippingDetails = (payload) => ({
  type: UPDATE_SHIPPING_DETAILS,
  payload
});
const updateShippingForms = (payload) => ({
  type: UPDATE_SHIPPING_FORMS,
  payload
});
const saveAddressLookup = (payload) => ({
  type: SAVE_ADDRESS_LOOKUP,
  payload
});
const markFieldsTouched = () => ({
  type: MARK_FIELDS_TOUCHED
});
const setMyAccountValidation = () => ({
  type: SET_MY_ACCOUNT_VALIDATION
});
const resetMyAccountValidation = () => ({
  type: RESET_MY_ACCOUNT_VALIDATION
});
const setServiceStoreValidation = () => ({
  type: SET_SERVICE_STORE_VALIDATION
});
const resetServiceStoreValidation = () => ({
  type: RESET_SERVICE_STORE_VALIDATION
});
export {
  MARK_FIELDS_TOUCHED,
  PREFILL_SHIPPING_FORMS,
  RESET_EXPRESS_CHECKOUT,
  RESET_MY_ACCOUNT_VALIDATION,
  RESET_SERVICE_STORE_VALIDATION,
  RESET_STORE,
  SAVE_ADDRESS_LOOKUP,
  SELECT_PICKUP_POINT,
  SELECT_SERVICE_STORE,
  SELECT_SHIPPING_METHOD,
  SELECT_STORE,
  SET_CONSENTS,
  SET_MY_ACCOUNT_VALIDATION,
  SET_SERVICE_STORE_VALIDATION,
  TOGGLE_CONSENT,
  TOGGLE_DELIVERY_ADDRESS,
  TOGGLE_EXPRESS_CHECKOUT,
  TOGGLE_INVOICE,
  TOGGLE_IS_COMPANY,
  UPDATE_SHIPPING_DETAILS,
  UPDATE_SHIPPING_FORMS,
  markFieldsTouched,
  prefillShippingForms,
  resetExpressCheckout,
  resetMyAccountValidation,
  resetServiceStoreValidation,
  resetStore,
  saveAddressLookup,
  selectPickupPoint,
  selectServiceStore,
  selectShippingMethod,
  selectStore,
  setConsents,
  setMyAccountValidation,
  setServiceStoreValidation,
  toggleConsent,
  toggleDeliveryAddress,
  toggleExpressCheckout,
  toggleInvoice,
  toggleIsCompany,
  updateShippingDetails,
  updateShippingForms
};
//# sourceMappingURL=actions.js.map
